<template>
  <div>
    <Pong></Pong>
  </div>
</template>

<script>
import Pong from "../components/pong.component";
import apiClientCreator from "../../../../helpers/api/request";

export default {
  name: "Pong.container",
  created() {
    window && window.addEventListener("message", this.saveScore, false);
  },

  mounted() {
    let scriptTag = document.createElement("script");
    scriptTag.setAttribute("src", "https://evolutioncrm-cdn.s3.amazonaws.com/global/content/js/pong.js");
    document.head.appendChild(scriptTag);
  },
  data() {
    return {
      src: "https://evolutioncrm-cdn.s3.amazonaws.com/global/content/js/pong.js"
    };
  },
  methods: {
    saveScore({ data }) {
      apiClientCreator(`users/score`)
        .post("", { score: data, game: "PONG" })
        .then(res => {
          return res;
        });
    }
  },
  components: { Pong }
};
</script>

<style scoped></style>
